<template>
	<div :class="{'hidden':hidden}" class="pagination-container">
		<el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize"
			:layout="layout" :page-sizes="pageSizes" :total="total" v-bind="$attrs" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" />
	</div>
</template>

<script>
	import {
		scrollTo
	} from '@/utils/scroll-to'
	import {
		mapActions,
		mapMutations
	} from 'vuex';
	export default {
		name: 'Pagination',
		props: {
			total: {
				required: true,
				type: Number
			},
			page: {
				type: Number,
				default: 1
			},
			limit: {
				type: Number,
				default: 20
			},
			pageSizes: {
				type: Array,
				default () {
					return [10, 20, 50, 100, 200, 500, 1000]
				}
			},
			layout: {
				type: String,
				default: 'total, sizes, prev, pager, next, jumper'
				// default: 'prev, pager, next'
			},
			background: {
				type: Boolean,
				default: true
			},
			autoScroll: {
				type: Boolean,
				default: true
			},
			hidden: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			currentPage: {
				get() {
					return this.page
				},
				set(val) {
					this.$emit('update:page', val)
				}
			},
			pageSize: {
				get() {
					return this.limit
				},
				set(val) {
					this.$emit('update:limit', val)
				}
			}
		},
		methods: {
			...mapMutations('public', ['SET_FENYE_INFO', 'REMOVE_FENYE_INFO']),
			handleSizeChange(val) {
				this.$emit('pagination', {
					page: this.currentPage,
					limit: val
				})
				if (this.autoScroll) {
					scrollTo(0, 800)
				}
			},
			handleCurrentChange(val) {
				// this.SET_FENYE_INFO(val);
				this.$emit('pagination', {
					page: val,
					limit: this.pageSize
				})
				if (this.autoScroll) {
					scrollTo(0, 800)
				}
			}
		}
	}
</script>

<style scoped>
	::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #D43733;
		color: #FFF;
	}

	::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #fff;
		background-color: #D43733;
	}
	::v-deep .el-input__inner {
		height: 32px;
		line-height: 32px;
	}
	
	
	/* 覆盖输入框获得焦点时的蓝色边框 */
	::v-deep .el-input__inner:focus {
		border-color: #DCDFE6 !important;
		box-shadow: 0 0 0 2px rgba(220, 223, 230, 0.2) !important;
	}
	
	/* 统一设置输入框默认边框 */
	::v-deep .el-input__inner {
		border: 1px solid #DCDFE6 !important;
	
		&:hover {
			border-color: #DCDFE6 !important;
		}
	}
	
	::v-deep .el-select-dropdown__item.selected {
	    color: #000;
	    font-weight: 700;
	}


	.pagination-container {
		/* background: #fff; */
		padding: 32px 16px;
	}

	.pagination-container.hidden {
		display: none;
	}
</style>